import React from 'react';

// includes
import ScrollToTop from './ScrollToTop';

// containers
import Home from './containers/Home';
import ProjectList from './containers/Projects/List';
import ProjectCategory from './containers/Projects/Category';
import ProjectDetails from './containers/Projects/Details';
import Services from './containers/Services';
import Practice from './containers/Practice';
import JournalList from './containers/Journals/List';
import JournalCategory from './containers/Journals/Category';
import JournalDetails from './containers/Journals/Details';
import JournalNew from './containers/Journals/JournalNew';
import LinkedProject from './containers/Projects/LinkedProject';
import NoPage from './containers/NoPage';


import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom'

function Layout(){
	return(
		<Router >
			<div className="fullW">	
				<ScrollToTop/>
				<Switch>
					<Route exact path={`${process.env.PUBLIC_URL}/`} component={Home}/>
					<Route exact path={`${process.env.PUBLIC_URL}/projects`} component={ProjectList}/>
					<Route exact path={`${process.env.PUBLIC_URL}/projects/:category`} component={ProjectCategory}/>
					<Route exact path={`${process.env.PUBLIC_URL}/project/:slug`} component={ProjectDetails}/>
					<Route exact path={`${process.env.PUBLIC_URL}/services/:slug`} component={Services}/>
					<Route exact path={`${process.env.PUBLIC_URL}/practice`} component={Practice}/>
					<Route exact path={`${process.env.PUBLIC_URL}/journals`} component={JournalList}/>
					<Route exact path={`${process.env.PUBLIC_URL}/journals/:category`} component={JournalCategory}/>
					<Route exact path={`${process.env.PUBLIC_URL}/journal/:slug`} component={JournalDetails}/>
					<Route exact path={`${process.env.PUBLIC_URL}/:link_type`} component={LinkedProject}/>

					<Route exact path={`${process.env.PUBLIC_URL}/journalNew/journalNew`} component={JournalNew}/>
				</Switch>
			</div>
		</Router>
	)
}
export default Layout;


// WEBPACK FOOTER //
// ./src/Layout.js